module.exports = __webpack_public_path__ + "static/media/Milagros_Rodriguez_C_EN.0c0b8057.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/store/Milagros_Rodriguez_C_EN.pdf
// module id = 231
// module chunks = 0